module.exports = [
  '/admin/*',
  '/myhsf/*',
  '/form-preview/*',
  '/eventbrite/*',
  '/programs/*',
  '/college-finder/*',
  '/scholarship-finder/*',
];
